
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/program/free-course/video-game",
      function () {
        return require("private-next-pages/program/free-course/video-game.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/program/free-course/video-game"])
      });
    }
  